import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SwipeableViews from 'react-swipeable-views';
import bindKeyboard from 'react-swipeable-views/lib/bindKeyboard';
import Button from '../common/ButtonComponent';
import { Pagination } from './Pagination';
import PaginationMobile from './PaginationMobile';
import { DemoGo } from './DemoGo';
import BrowserUtils from '../../utils/BrowserUtils';
import { isBOrVMRetail, isCB, isYB } from '../../utils/BrandUtils';

const AutoPlaySwipeableViews = bindKeyboard(SwipeableViews);

const styles = {
  slide: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#f3f3f3',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  slideGreen: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#00db6d',
    textAlign: 'center',
    paddingBottom: '50px',
  },
  slideRed: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#e0242a',
    textAlign: 'center',
    paddingBottom: '50px',
  },
  slideBlue: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#0098d7',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  mobilesSlide: {
    padding: 15,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#f8f8f8',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  img: {
    width: 973,
  },
};

/**
 * @todo
 * This component is of poor quality.
 * It may not even actually be used in the codebase today.
 * Future improvement work should be undertaken to refactor/remove this component
 * to increase the health of the codebase.
 */
class Demo extends Component {
  constructor(props) {
    super(props);

    this.changeBackgroundFluidFull = this.changeBackgroundFluidFull.bind(this);
    this.changeBackgroundGutters = this.changeBackgroundGutters.bind(this);
    this.changeBackgroundInternalDiv =
      this.changeBackgroundInternalDiv.bind(this);
    this.closed = this.closed.bind(this);
    this.demoText = this.demoText.bind(this);
    this.demodonePage = this.demodonePage.bind(this);
    this.disabledLeftIcon = this.disabledLeftIcon.bind(this);
    this.disabledRightIcon = this.disabledRightIcon.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.handleChangeMobileIndex = this.handleChangeMobileIndex.bind(this);
    this.isMobileDevice = this.isMobileDevice.bind(this);
    this.swipeLeft = this.swipeLeft.bind(this);
    this.swipeRight = this.swipeRight.bind(this);
    this.renderHelpDemoPages = this.renderHelpDemoPages.bind(this);
    this.renderHelpDemoWeb = this.renderHelpDemoWeb.bind(this);
    this.renderHelpDomeMobile = this.renderHelpDomeMobile.bind(this);

    this.state = {
      index: 0,
      Go: false,
    };
  }

  changeBackgroundFluidFull() {
    const index = this.isMobileDevice() ? 7 : 11;
    if (this.state.index === index) {
      return 'b container-fluid-full help bg-help greenBackground';
    } else {
      return 'b container-fluid-full help bg-help';
    }
  }

  changeBackgroundGutters() {
    const index = this.isMobileDevice() ? 7 : 11;
    if (this.state.index === index) {
      return 'row no-gutters greenBackground';
    } else {
      return 'row no-gutters demo';
    }
  }

  changeBackgroundInternalDiv() {
    const index = this.isMobileDevice() ? 7 : 11;
    if (this.state.index === index) {
      return 'col-lg-12 col-md-12 demo-title full-height greenBackground';
    } else {
      return 'col-lg-12 col-md-12 demo-title';
    }
  }

  closed() {
    this.setState({ Go: false });
  }

  // To get the text under every image.
  demoText(index) {
    if (this.isMobileDevice()) {
      const demoMsg = [
        '',
        'Timeline',
        'Tagging',
        'Payments',
        'Alerts & Sweeps',
        'Sweeps',
        'Help',
      ];
      return demoMsg[index];
    } else {
      const demoMsg = [
        '',
        'Timeline',
        'Insights',
        'Tagging',
        'Spending',
        'Savings Pots',
        'Payments',
        'Alerts and Messages',
        'Sweeps',
        'Projections',
        'Help',
      ];
      return demoMsg[index];
    }
  }

  demodonePage() {
    if (isCB()) {
      return (
        <div style={_.assign({}, styles.mobilesSlide, styles.slideRed)}>
          <DemoGo {...this.props} closed={this.props.closed} />
        </div>
      );
    } else if (isYB()) {
      return (
        <div style={_.assign({}, styles.mobilesSlide, styles.slideBlue)}>
          <DemoGo {...this.props} closed={this.props.closed} />
        </div>
      );
    } else if (isBOrVMRetail()) {
      return (
        <div style={_.assign({}, styles.mobilesSlide, styles.slideGreen)}>
          <DemoGo {...this.props} closed={this.props.closed} />
        </div>
      );
    }
  }

  disabledLeftIcon() {
    if (this.state.index === 0) {
      return 'icon icon-page-back icon-arrow-disabled';
    } else {
      return 'icon icon-page-back';
    }
  }

  disabledRightIcon() {
    const index = this.isMobileDevice() ? 7 : 11;
    if (this.state.index === index) {
      return 'icon icon-page-next icon-arrow-disabled';
    } else {
      return 'icon icon-page-next';
    }
  }

  // On click change the index of dot.
  handleChangeIndex(index) {
    if (index === 0 && this.state.index === 10) {
      this.setState({ Go: true });
    }
    if (index === 10 && this.state.index === 0) {
      return false;
    }
    this.setState({
      index,
    });
  }

  handleChangeMobileIndex(index) {
    if (index === 0 && this.state.index === 6) {
      this.setState({ Go: true });
    }
    if (index === 6 && this.state.index === 0) {
      return false;
    }
    this.setState({
      index,
    });
  }

  isMobileDevice() {
    return BrowserUtils.isMobileView();
  }

  // Demo images will be moved left side.
  swipeLeft() {
    if (this.state.index > 0) {
      this.setState({ index: this.state.index - 1 });
    }
  }

  // Demo images will be moved right side.
  swipeRight() {
    const index = this.isMobileDevice() ? 7 : 11;
    if (this.state.index === index) {
      this.setState({ Go: true });
    } else {
      this.setState({
        index: this.state.index + 1,
      });
    }
  }

  renderHelpDemoPages() {
    if (this.isMobileDevice()) {
      return this.renderHelpDomeMobile();
    } else {
      return this.renderHelpDemoWeb();
    }
  }

  renderHelpDemoWeb() {
    return (
      <div className={this.changeBackgroundInternalDiv()}>
        <a className={this.disabledLeftIcon()} onClick={this.swipeLeft} />
        <AutoPlaySwipeableViews
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        >
          <div style={_.assign({}, styles.slide, styles.slide1)}>
            <img
              style={_.assign({}, styles.img)}
              className="big-b"
              width="20%"
              src="../images/b/icons/Demo-B.png"
              alt=""
              title=""
            />
            <p>{this.props.content.BImg}</p>
          </div>
          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/timeline.png"
              alt=""
              title=""
            />
            <p>{this.props.content.TimelineImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Insights.png"
              alt=""
              title=""
            />
            <p>{this.props.content.InsightsImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Tagging.png"
              alt=""
              title=""
            />
            <p>{this.props.content.TaggingImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Spending.png"
              alt=""
              title=""
            />
            <p>{this.props.content.SpendingImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/SavingsPots.png"
              alt=""
              title=""
            />
            <p>{this.props.content.SavingsPotsImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Payments.png"
              alt=""
              title=""
            />
            <p>{this.props.content.PaymentsImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide1)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Alerts&Messages.png"
              alt=""
              title=""
            />
            <p>{this.props.content.AlertsMessagesImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Sweeps.png"
              alt=""
              title=""
            />
            <p>{this.props.content.SweepsImg} </p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide3)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Projections.png"
              alt=""
              title=""
            />
            <p>{this.props.content.ProjectionsImg}</p>
          </div>

          <div style={_.assign({}, styles.slide, styles.slide2)}>
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Help.png"
              alt=""
              title=""
            />
            <p>{this.props.content.HelpImg}</p>
          </div>
          {this.demodonePage()}
        </AutoPlaySwipeableViews>
        <a className={this.disabledRightIcon()} onClick={this.swipeRight} />
        <Pagination
          dots={12}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        />
      </div>
    );
  }

  renderHelpDomeMobile() {
    return (
      <div className={this.changeBackgroundInternalDiv()}>
        <a className={this.disabledLeftIcon()} onClick={this.swipeLeft} />
        <AutoPlaySwipeableViews
          index={this.state.index}
          onChangeIndex={this.handleChangeMobileIndex}
        >
          <div style={_.assign({}, styles.mobilesSlide, styles.slide1)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MlaunchB.png"
              alt=""
              title=""
            />
          </div>
          <div style={_.assign({}, styles.mobilesSlide, styles.slide3)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/Mtimeline.png"
              alt=""
              title=""
            />
          </div>

          <div style={_.assign({}, styles.mobilesSlide, styles.slide3)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MTagging.png"
              alt=""
              title=""
            />
          </div>
          <div style={_.assign({}, styles.mobilesSlide, styles.slide3)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MPayments.png"
              alt=""
              title=""
            />
          </div>

          <div style={_.assign({}, styles.mobilesSlide, styles.slide1)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MAlerts.png"
              alt=""
              title=""
            />
          </div>

          <div style={_.assign({}, styles.mobilesSlide, styles.slide3)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MCreateSweeps.png"
              alt=""
              title=""
            />
          </div>
          <div style={_.assign({}, styles.mobilesSlide, styles.slide2)}>
            <img
              style={_.assign({})}
              width="100%"
              src="../images/b/MNeedhelp.png"
              alt=""
              title=""
            />
          </div>
          {this.demodonePage()}
        </AutoPlaySwipeableViews>
        <a className={this.disabledRightIcon()} onClick={this.swipeRight} />
        <PaginationMobile
          dots={8}
          index={this.state.index}
          onChangeIndex={this.handleChangeMobileIndex}
        />
      </div>
    );
  }

  render() {
    return (
      <div className={this.changeBackgroundFluidFull()}>
        <div className={this.changeBackgroundGutters()}>
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-3 text-left">
            <Button
              btnName="< Back"
              className="button button--link u-strong"
              onClick={this.props.closed}
            />
          </div>
          <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 text-center">
            {this.state.index > 0 ? (
              <h3>
                <b>{this.demoText(this.state.index)}</b>
              </h3>
            ) : (
              <h3>&nbsp; </h3>
            )}
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-3" />
        </div>
        {this.renderHelpDemoPages()}
      </div>
    );
  }
}

Demo.propTypes = {
  content: PropTypes.object,
  closed: PropTypes.func,
};

export { Demo };
